import stanDodatkowy from '@components/search/inputs/stanDodatkowy'
import bezwypadkowy from '@components/search/inputs/bezwypadkowy'

const stanPojazdu = { t: 'Stan pojazdu', inputs: [
    { t: 'Uszkodzony', type: 'all-checkbox', name: 'uszkodzone', options: ['Tak', 'Nie'], names: ['uszkodzone', 'nie-uszkodzone']},
    bezwypadkowy,
    stanDodatkowy,
]}

export default stanPojazdu